<h4 class="panel-title panel-title--{{ variant }}">
  <ng-content></ng-content>
</h4>
